import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { useAuth } from "../../Context/AuthContext";
import MyPatientList from "./MyPatientList";
import PatientList from "./PatientList";
import AssignedPatientList from "./AssignedPatientList";

const PatientTabs = ({ imported, search }) => {
  const [selectedPatient, setSelectedpatient] = useState();
  const [getList, setgetList] = useState(false);
  const { isAdmin } = useAuth();
  const [sortBy, setSortBy] = useState("");
  const [dropDownList, setDropDownList] = useState(false);

  const onselectpatient = (patientdetails) => {
    setSelectedpatient(patientdetails);
  };

  // const onStatusChange = (status) => {
  //   setSelectedpatient({ ...selectedPatient, status: status });
  //   setgetList(!getList);
  //   setgetMyList(!getMyList);
  // };

  const renderMyPatient = () => {
    return (
      <div className="row">
        <div className="col-md-12">
          <MyPatientList
            onselectpatient={onselectpatient}
            selectedPatient={selectedPatient}
            getList={getList}
            search={search}
            imported={imported}
            sortBy={sortBy}
          />
        </div>
        {/* <div className="col-md-8">
          <AllPatientListRightSection onStatusChange={onStatusChange} selectedPatient={selectedPatient} />
        </div> */}
      </div>
    );
  };

  const renderAssignedClient = () => {
    return (
      <div className="row">
        <div className="col-md-12">
          <AssignedPatientList
            onselectpatient={onselectpatient}
            selectedPatient={selectedPatient}
            getList={getList}
            search={search}
            imported={imported}
            sortBy={sortBy}
          />
        </div>
        {/* <div className="col-md-8">
          <AllPatientListRightSection onStatusChange={onStatusChange} selectedPatient={selectedPatient} />
        </div> */}
      </div>
    );
  };

  const renderAllPatient = () => {
    return (
      <div className="row">
        <div className="col-md-12">
          <PatientList
            onselectpatient={onselectpatient}
            selectedPatient={selectedPatient}
            getList={getList}
            search={search}
            imported={imported}
            sortBy={sortBy}
          />
        </div>
        {/* <div className="col-md-8">
          <AllPatientListRightSection onStatusChange={onStatusChange} selectedPatient={selectedPatient} />
        </div> */}
      </div>
    );
  };

  const navigate = useNavigate();
  const [params] = useSearchParams();

  const [selectedTab, setSelectedTab] = useState(
    parseInt(params.get("tab") ? params.get("tab") : 0)
  );

  useEffect(() => {
    navigate({
      search: `?tab=${selectedTab}`,
    });
    // if(selectedTab == 0) document.getElementsByClassName("memlist_scroll")[0].firstElementChild.click()
  }, [selectedTab]);

  const menuClass = `dropdown-menu${dropDownList ? " show" : ""}`;

  if (isAdmin) {
    return (
      <div className="position-relative">
        <Tabs
          selectedIndex={selectedTab}
          onSelect={(index) => {
            setSortBy("");
            setSelectedTab(index);
          }}
        >
          <TabList>
            <Tab>My Clients</Tab>
            <Tab>All Clients</Tab>
          </TabList>
          <TabPanel>{selectedTab === 0 && renderMyPatient()}</TabPanel>
          <TabPanel>{selectedTab === 1 && renderAllPatient()}</TabPanel>
        </Tabs>
        <div
          className="dropdown me-2 position-absolute "
          style={{ top: "-20px", right: "0px" }}
        >
          <button
            onBlur={() => {
              setDropDownList(false);
            }}
            onClick={() => {
              setDropDownList(!dropDownList);
            }}
            className="btn btn-custom-filter position-relative dropdown-toggle"
            type="button"
          >
            {sortBy === "atoz" ? 'Alphabetical' : sortBy === 'bydate' ? "Date" : "Filter"}
            <ul
              className={menuClass + " top-0 w-100"}
              style={{ marginTop: "3.5em" }}
            >
              <li>
                <span
                  className="dropdown-item pointer"
                  onClick={() => {
                    setSortBy("atoz");
                  }}
                >
                  Alphabetical Order
                </span>
              </li>
              <li>
                <span
                  className="dropdown-item pointer"
                  onClick={() => {
                    setSortBy("bydate");
                  }}
                >
                  Date Order
                </span>
              </li>
            </ul>
          </button>
        </div>
      </div>
    );
  }
  return (
    <div className="position-relative ">
      <Tabs
        selectedIndex={selectedTab}
        onSelect={(index) => {
          setSortBy("");
          setSelectedTab(index);
        }}
      >
        <TabList>
          <Tab>My Clients</Tab>
          <Tab>Assigned Clients</Tab>
          <Tab>All Clients</Tab>
        </TabList>
        <TabPanel>{selectedTab === 0 && renderMyPatient()}</TabPanel>
        <TabPanel>{selectedTab === 1 && renderAssignedClient()}</TabPanel>
        <TabPanel>{selectedTab === 2 && renderAllPatient()}</TabPanel>
      </Tabs>
      <div
        className="dropdown me-2 position-absolute "
        style={{ top: "-20px", right: "0px" }}
      >
        <button
          onBlur={() => {
            setDropDownList(false);
          }}
          onClick={() => {
            setDropDownList(!dropDownList);
          }}
          className="btn btn-custom-filter position-relative dropdown-toggle"
          type="button"
        >
          {sortBy === "atoz" ? 'Alphabetical' : sortBy === 'bydate' ? "Date" : "Filter"}
          <ul
            className={menuClass + " top-0 w-100"}
            style={{ marginTop: "3.5em" }}
          >
            <li>
              <span
                className="dropdown-item pointer"
                onClick={() => {
                  setSortBy("atoz");
                }}
              >
                Alphabetical Order
              </span>
            </li>
            <li>
              <span
                className="dropdown-item pointer"
                onClick={() => {
                  setSortBy("bydate");
                }}
              >
                Date Order
              </span>
            </li>
          </ul>
        </button>
      </div>
    </div>
  );
};

export default PatientTabs;
